export default {
      id: "common__filter_on-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__filter_on",
      toString: function () {
        return this.url;
      }
    }